import { ReleasePageFormDataWithName } from '@features/Funnel/screens/FunnelPage/ReleasePage/ReleasePageScreen';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { releasePayloadFactory } from '../../utils/releaseFunnelsPageFactory';

interface UpdateReleaseFunnelPageRequest {
  id: string;
  payload: ReleasePageFormDataWithName;
}

export function useTryToRequestUpdateReleasePage() {
  const navigate = useNavigate();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({ id, payload }: UpdateReleaseFunnelPageRequest) => {
      const factory = await releasePayloadFactory(payload);
      return await apiCancellationFunnels.tryToRequestUpdateCancellationFunnelPage(
        id,
        factory
      );
    },
    onSuccess: () => {
      navigate(-1);
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao editar o funil de Lançamento',
        'Ocorreu um erro ao editar o funil de Lançamento, por favor tente novamente mais tarde.'
      );
    },
  });

  return {
    tryToRequestUpdateReleasePage: mutateAsync,
    isLoadingReleaseUpdate: isPending,
  };
}
